import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { downloadcicdReport } from '../AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/Loader.component'
export default function CICDReport() {
    const [loader, setLoader] = useState(false)
    const [payload, setPayload] = useState({
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
    })

    const downloadReport = () => {
        setLoader(true)
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")
        downloadcicdReport(start, end, callback => {
            setLoader(false)
        })
    }

    const handlechange =(e,type)=>{
        setPayload((prev)=>({
            ...prev,
            [type]:e.target.value
        }))
    }
    return (
        <>
            <div className="container-fluid">
                {
                    loader ? <Loader /> : ''
                }

                <h3 className='text-center blue-text'>CIC REPORT</h3>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Start Date</label>
                        <input type="date" value={payload?.startDate} className='form-control' onChange={(e)=>handlechange(e,"startDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">End Date</label>
                        <input type="date" value={payload?.endDate} className='form-control' onChange={(e)=>handlechange(e,"endDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button className='btn btn-primary' style={{ padding: '10px', marginTop: '22px' }} onClick={() => downloadReport()}><i class="fa fa-download" aria-hidden="true"></i>&nbsp; Download</button>
                    </div>
                </div>
            </div>
        </>
    )
}
